import ClientsTnc from './student_tnc/ClientsTnc'
import TherapistTnc from './student_tnc/TherapistTnc'


export default <><ClientsTnc/><TherapistTnc/></>